import { createStore } from "vuex";
import getters from "./getters";
import app from "./modules/app";
import user from "./modules/user";
import settings from "./modules/settings";
import appEditor from "./modules/appEditor";
export default createStore({
  modules: {
    app,
    user,
    settings,
    appEditor,
  },
  getters,
});
